import React, { useState } from 'react';
import { FilterContext } from './filter-context';

export const FilterContextProvider = (props) => {
  const [filterBar, setFilterBar] = useState({
    getFilters: () => ({}),
  });

  return (
    <FilterContext.Provider
      value={{
        filterBar,
        setFilterBar,
      }}
    >
      {props.children}
    </FilterContext.Provider>
  );
};

export const withFilterContext = Component => props => (<FilterContextProvider><Component {...props} /></FilterContextProvider>);
